import script from "./PublicCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicCourse.vue?vue&type=script&setup=true&lang=js"

import "./PublicCourse.vue?vue&type=style&index=0&id=5a67180b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a67180b"]])

export default __exports__